import $ from 'jquery';
import config from './config';
import Loader from './loader';
import overlay from './overlay';

let $cnt;
let $form;
let $resultsCnt;
let $pageOverlay;
const activeClass = 'search-top--active';
let loader;
let hideOverlay;
let showOverlay;
let $closeSearch;
let $showSearch;
let $input;

$pageOverlay = $('.page-overlay');

function submit() {
  return $.get($form.attr('action'), {
    query: $input.val(),
  });
}

function submitSuccess(res) {
  $resultsCnt.html(res);
}

function submitError() {
  $resultsCnt.html('<p class="paragraph paragraph--bigger error">Wystąpił błąd. Spróbuj ponownie później.</p>');
}

function submitAlways() {
  loader.remove();
}

function open() {
  showOverlay();
  config.$el.body.addClass(activeClass);
  $input[0].focus();
}

function close() {
  hideOverlay();
  config.$el.body.removeClass(activeClass);
  $form.find('input').val('');
  $resultsCnt.html('');
}

function setEvents() {
  $form.on('submit', e => {
    e.preventDefault();

    loader.show();

    submit()
      .done(submitSuccess)
      .error(submitError)
      .always(submitAlways);
  });
  $showSearch.on('click', open);
  $closeSearch.on('click', close);
}

function init() {
  $cnt = $('.search-top');
  $form = $('.search-top__form');
  $resultsCnt = $('.search-top__results');
  loader = new Loader($form);
  $pageOverlay = $('.page-overlay');
  $closeSearch = $cnt.find('.search-top__close');
  hideOverlay = overlay.hideOverlay.bind(null, $pageOverlay);
  showOverlay = overlay.showOverlay.bind(null, $pageOverlay);
  $showSearch = $('.menu__search');
  $input = $form.find('.search-top__input');

  setEvents();
}

function resize() {
  if (!$('.nav-active').length && !$('.page-overlay').hasClass('hidden') && $cnt && !$cnt.is(':visible')) {
    close();
  }
}

export default {
  init,
  resize,
};



// WEBPACK FOOTER //
// ./front/iko-app-lite/js/app/search.js